export default __webpack_public_path__ + "static/media/no-feedback.85b5ab0f.svg";